import AddDepartmentForm from 'components/form/super-admin/master/department/AddDepartmentForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'


export default class AddDepartment extends Component {
    render() {
        return (
            <>
                <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Add Department</h4>
                                <AddDepartmentForm />
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
